import React from 'react';
import { VNode } from '@algolia/autocomplete-js';
import { EmptyPreviewState } from '../EmptyPreviewState';
import styles from './QuickAccess.module.scss';

interface Props {
	programsPlugin: VNode;
	recommendedProgramsPlugin: VNode;
	staticTotalPrograms: number;
}

export const QuickAccess: React.FC<Props> = ({
	programsPlugin,
	recommendedProgramsPlugin,
	staticTotalPrograms,
}) => {
	return (
		<div className={styles.aaPanelSectionRight}>
			{programsPlugin && <div className={styles.aaPanelSectionPrograms}>{programsPlugin}</div>}

			{recommendedProgramsPlugin && (
				<div className={styles.aaPanelSectionPrograms}>{recommendedProgramsPlugin}</div>
			)}

			{!programsPlugin && !recommendedProgramsPlugin && (
				<EmptyPreviewState staticTotalPrograms={staticTotalPrograms} />
			)}
		</div>
	);
};
